import { useState } from 'react';
import { Badge } from '../ui/Badge';

const PAGE_TITLES = {
  '/':            'Tableau de bord',
  '/validations': 'Validations entreprises',
  '/commandes':   'Commandes',
  '/laveries':    'Gestion des laveries',
  '/livreurs':    'Gestion des livreurs',
  '/clients':     'Gestion des clients',
  '/promos':      'Codes promotionnels',
  '/services':    'Services & Prix',
  '/support':          'Support & Réclamations',
  '/change-password':  'Sécurité — Changement de mot de passe',
  '/parametres':       'Paramètres',
};

export const Topbar = ({ pathname }) => {
  const base = '/' + (pathname?.split('/')[1] || '');
  const title = PAGE_TITLES[base] || 'LAVEX Admin';
  const [apiUrl] = useState(process.env.REACT_APP_API_URL || 'localhost:3000');

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h1 className="page-title">{title}</h1>
      </div>
      <div className="topbar-right">
        <div className="api-badge">API: {apiUrl}</div>
        <Badge className="badge-green" dot>En ligne</Badge>
      </div>
    </div>
  );
};
